import { makeAutoObservable } from "mobx";
import { ApiResponse, IRootStore } from "..";
import Api from "../../services/api";
import { ApiConfig } from "../../services/api-config";
import _ from "lodash";
import { IDeliveryDriver } from ".";

export default class DeliveryStore {
  drivers: Array<IDeliveryDriver> = [];
  editDriver: IDeliveryDriver | null = null;
  private rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  //#region Drivers
  fetchDrivers = () => {
    const url = ApiConfig.REST_URIS.delivery.fetchDrivers;
    Api.get(url, (res: ApiResponse<IDeliveryDriver[]>) => {
      if (res?.isSuccess && res.data) {
        this.drivers = _.sortBy(res.data, "name");
      }
    });
  };

  saveDriver = (driver: IDeliveryDriver, callback: Function) => {
    if (driver.deliveryDriverId) {
      Api.put(
        ApiConfig.REST_URIS.delivery.updateDriver(driver.deliveryDriverId),
        driver,
        (res: ApiResponse<number>) => {
          callback && callback(res?.isSuccess && res.data);
        }
      );
    } else {
      Api.post(
        ApiConfig.REST_URIS.delivery.createDriver,
        driver,
        (res: ApiResponse<number>) => {
          callback && callback(res?.isSuccess && res.data);
        }
      );
    }
  };

  deleteDriver = (driverId: number, callback: Function) => {
    const url = ApiConfig.REST_URIS.delivery.deleteDriver(driverId);

    Api.delete(url, (res: ApiResponse<number>) => {
      callback && callback(res?.isSuccess && res.data);
    });
  };

  setEditDriver = (driver: IDeliveryDriver | null) => {
    this.editDriver = driver;
  };
  //#endregion
}
